import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import Header from '../Common/Header';
import Sidebar from '../Common/Sidebar';
import Footer from '../Common/Footer';
import { GMCContext } from '../../GMCContext';
import { getTickets } from '../../supportService';
import { FaEye, FaFilter } from 'react-icons/fa';
import toast from 'react-hot-toast';

export default function TicketsList() {
    const { isDarkMode, formatDateTime } = useContext(GMCContext);
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState({
        status: '',
        priority: ''
    });

    const headerHeight = 70;

    const fetchTickets = async () => {
        setLoading(true);
        try {
            // Remove empty query params before sending
            const params = {};
            if (filters.status) params.status = filters.status;
            if (filters.priority) params.priority = filters.priority;

            const response = await getTickets(params);
            console.log('tickets', response);

            // Always read data from response.data.data
            setTickets(response?.tickets || []);
        } catch (error) {
            console.error("Failed to load tickets", error);
            toast.error("Failed to load tickets");
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchTickets();
    }, [filters]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const getStatusBadge = (status) => {
        switch (status?.toLowerCase()) {
            case 'open': return <span className="badge bg-success">Open</span>;
            case 'in-progress': return <span className="badge bg-warning text-dark">In Progress</span>;
            case 'closed': return <span className="badge bg-secondary">Closed</span>;
            default: return <span className="badge bg-light text-dark">{status}</span>;
        }
    };

    const getPriorityBadge = (priority) => {
        switch (priority?.toLowerCase()) {
            case 'high': return <span className="badge bg-danger">High</span>;
            case 'medium': return <span className="badge bg-warning text-dark">Medium</span>;
            case 'low': return <span className="badge bg-info">Low</span>;
            default: return <span className="badge bg-light text-dark">{priority}</span>;
        }
    };

    return (
        <>
            <Header />
            <Sidebar />
            <div
                className={`main-content ${isDarkMode ? "bg-dark text-light" : "bg-light"}`}
                style={{
                    marginTop: `${headerHeight}px`,
                    minHeight: `calc(100vh - ${headerHeight}px - 50px)`,
                    padding: "30px"
                }}
            >
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="fw-bold mb-0">Support Tickets</h4>

                    <div className="d-flex gap-2">
                        <select
                            className="form-select form-select-sm"
                            style={{ width: '150px' }}
                            name="status"
                            value={filters.status}
                            onChange={handleFilterChange}
                        >
                            <option value="">All Statuses</option>
                            <option value="open">Open</option>
                            <option value="in-progress">In Progress</option>
                            <option value="closed">Closed</option>
                        </select>

                        <select
                            className="form-select form-select-sm"
                            style={{ width: '150px' }}
                            name="priority"
                            value={filters.priority}
                            onChange={handleFilterChange}
                        >
                            <option value="">All Priorities</option>
                            <option value="high">High</option>
                            <option value="medium">Medium</option>
                            <option value="low">Low</option>
                        </select>

                        <button className="btn btn-primary btn-sm" onClick={fetchTickets}>
                            <FaFilter className="me-1" /> Refresh
                        </button>
                    </div>
                </div>

                <div className="card border-0 shadow-sm">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className={`table align-middle table-nowrap mb-0 ${isDarkMode ? 'table-dark' : 'table-hover'}`}>
                                <thead className="table-light">
                                    <tr>
                                        <th scope="col">Ticket ID</th>
                                        <th scope="col">User Address</th>
                                        <th scope="col">Subject</th>
                                        <th scope="col">Priority</th>
                                        <th scope="col">Status</th>
                                        <th scope="col">Last Updated</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="7" className="text-center py-5">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : tickets.length === 0 ? (
                                        <tr>
                                            <td colSpan="7" className="text-center py-5 text-muted">
                                                No tickets found
                                            </td>
                                        </tr>
                                    ) : (
                                        // Sort by latest updated first
                                        [...tickets]
                                            .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
                                            .map((ticket) => (
                                                <tr key={ticket._id || ticket.id}>
                                                    <td className="fw-medium">{ticket.ticketId || ticket.ticketId}</td>
                                                    <td>{ticket.userAddress || ticket.address || 'N/A'}</td>
                                                    <td>{ticket.subject}</td>
                                                    <td>{getPriorityBadge(ticket.priority)}</td>
                                                    <td>{getStatusBadge(ticket.status)}</td>
                                                    <td>{formatDateTime ? formatDateTime(ticket.updatedAt) : new Date(ticket.updatedAt).toLocaleString()}</td>
                                                    <td>
                                                        <Link to={`/support/${ticket.ticketId || ticket.ticketId}`} className="btn btn-sm btn-soft-primary">
                                                            <FaEye /> View
                                                        </Link>

                                                    </td>
                                                </tr>
                                            ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}
